export enum ForumThreadType {
    Organization = 0,
    Program = 1,
    Activity = 2,
    Course = 3,
    HelpDesk = 4
}